// import { scan } from "react-scan"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import { Provider } from "react-redux"
import { store as reduxStore } from "./app/store"
import "@radix-ui/themes/styles.css"
import "./index.css"
import { Theme } from "@radix-ui/themes"
import Clarity from "@microsoft/clarity"
import { ConvexAuthProvider } from "@convex-dev/auth/react"
import { ClerkProvider, useAuth } from "@clerk/clerk-react"
import { ConvexProviderWithClerk } from "convex/react-clerk"

import { ConvexReactClient } from "convex/react"
import { ThemeProvider } from "@mui/material"
import { liveDrawTheme } from "./themes"

import * as Sentry from "@sentry/react"

if (
  import.meta.env.MODE === "production" &&
  window.location.hostname !== "localhost" &&
  !window.location.hostname.includes("netlify")
) {
  Clarity.init("ql5ni1c83b")

  Sentry.init({
    dsn: "https://c5b4da79d71cf0f8a579c96eacfc3831@o4509561431785472.ingest.us.sentry.io/4509561434079233",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}

// scan({
//   enabled: false, // true,
// })

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string)

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

console.log("Clerk publishable key:", clerkPublishableKey)

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <Provider store={reduxStore}>
          <Theme>
            <ThemeProvider theme={liveDrawTheme}>
              <App />
            </ThemeProvider>
          </Theme>
        </Provider>
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </StrictMode>,
)
